import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { Connect, PropsFromRedux } from './FolderItemContainer';
import { Folder } from '../folders.types';
import { FoldersToastDecisionRemoved } from '../toast/FoldersToast';
import { CloseToasterButton } from '../../components/toaster/close/CloseToasterButton';
import styles from './folder_item.module.scss';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';
import { useUser } from '../../user/useUser';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';

type Props = {
  docId: string;
  folder: Folder;
  source: string;
} & PropsFromRedux;

export const RawFolderItem: FC<Props> = ({
  folder,
  source,
  onRemoveClicked,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const removeFromFolder = () => {
    if (!accessPremium)
      return openRestrictedModal({ source: 'remove-from-folder' });
    onRemoveClicked();
    toast(
      <FoldersToastDecisionRemoved
        to={`/dossiers/${folder.folderKey}?source=folder-toaster-delete`}
      >
        {folder.title}
      </FoldersToastDecisionRemoved>,
      {
        autoClose: 7000,
        pauseOnHover: true,
        closeOnClick: false,
        closeButton: <CloseToasterButton />,
      },
    );
  };
  const linkProps = accessPremium
    ? {
        to: buildUrlWithParameters(`/dossiers/${folder.folderKey}`, {
          source,
        }),
      }
    : { to: '' };

  return (
    <div className={styles.container}>
      <Link className={styles.link} {...linkProps}>
        {folder.title}
      </Link>
      <button
        type="button"
        className={styles.close}
        onClick={removeFromFolder}
        name="remove-from-folder"
      >
        <MaterialIcon name="close" className={styles.icon} />
      </button>
    </div>
  );
};

export const FolderItem = Connect(RawFolderItem);
